<ng-container *ngIf="parentItemWebCode && servicePlans?.length > 0">
    <div class="row">
        <div class="col-xs-12 mt-2" [style.paddingTop]="isOnCartPage ? '0px' : '7px'">
            <h3 *ngIf="!isOnCartPage">Protect yourself with our extended service plans!</h3>
            <h5 *ngIf="isOnCartPage">Protect yourself with our extended service plans!</h5>
        </div>
    </div>
    <div class="row new-border-bottom mb-3 pb-3 service-plan-content">
        <div class="loading-container vistekweb" *ngIf="!isOnCartPage && isLoading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="col-xs-12 col-lg-6 mt-3 service-plans-column" *ngFor="let servicePlan of servicePlans">
            <div class="media service-plan-details">
                <img
                    alt=""
                    src="{{ getPlanImageURL(servicePlan.ImageDataburst) }}"
                    class="align-self-start mr-3"
                />

                <div class="media-body service-plan-description">
                    <div class="service-plan-title">
                        <span
                            class="mt-1 text-primary hand pop"
                            mdbPopover="{{ servicePlan.ShortCopy }}"
                            triggers="hover"
                            placement="top"
                            mdbPopoverHeader="Protection plan details:"
                            mdbWavesEffect
                        >
                            {{ servicePlan.Description }} <i class="fas fa-info-circle"></i>
                        </span>
                    </div>

                    <h6 class="mb-3 service-plan-price">
                        <strong>{{ servicePlan.Price | currency }}</strong>

                        <div *ngIf="addedWarranty && addedWarranty.ResourceCode === servicePlan.ResourceCode" class="btn btn-link btn-sm added-text">
                            <i class="fa fa-check"></i> Added!
                        </div>

                        <button *ngIf="!addedWarranty" class="btn btn-link btn-sm" (click)="addServicePlan(servicePlan)" data-test='add-protection-plan'>
                            <i class="fa fa-plus"></i> Add
                        </button>
                    </h6>
                </div>
            </div>
        </div>
    </div>
</ng-container>
